import dayjs from 'dayjs';

export function test() {
	return null;
}

export function getOS() {
	const { userAgent } = window.navigator;
	const { platform } = window.navigator;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'MacOS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	// @ts-ignore
	document.documentElement.setAttribute('os', os);
	return os;
}

export const hasNotch = () => {
	/**
	 * For storybook test
	 */
	const storybook = window.location !== window.parent.location;
	// @ts-ignore
	const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
	const aspect = window.screen.width / window.screen.height;
	const aspectFrame = window.innerWidth / window.innerHeight;
	return (
		(iPhone && aspect.toFixed(3) === '0.462') ||
		(storybook && aspectFrame.toFixed(3) === '0.462')
	);
};

export const mergeRefs = (refs: any[]) => {
	return (value: any) => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(value);
			} else if (ref != null) {
				ref.current = value;
			}
		});
	};
};

export const randomColor = () => {
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

	const color = Math.floor(Math.random() * colors.length);

	return colors[color];
};

export const priceFormat = (price: number) => {
	return price.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});
};

export const average = (array: any[]) => array.reduce((a, b) => a + b) / array.length;

export const percent = (value1: number, value2: number) =>
	Number(((value1 / value2 - 1) * 100).toFixed(2));

export const getFirstLetter = (text: string, letterCount = 2): string =>
	// @ts-ignore
	text
		.toUpperCase()
		.match(/\b(\w)/g)
		.join('')
		.substring(0, letterCount);

export const debounce = (func: (arg0: any) => void, wait = 1000) => {
	let timeout: string | number | NodeJS.Timeout | undefined;

	return function executedFunction(...args: any[]) {
		const later = () => {
			clearTimeout(timeout);
			// @ts-ignore
			func(...args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};

export const capitalizeFirst = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const downloadImage = (imageUrl: string, imageName: string): void => {
	fetch(imageUrl, {
		method: 'GET',
		headers: {},
	})
		.then((response) => {
			response.arrayBuffer().then(function (buffer) {
				const url = window.URL.createObjectURL(new Blob([buffer]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', imageName); //or any other extension
				document.body.appendChild(link);
				link.click();
			});
		})
		.catch((err) => {
			console.log(err);
		});
};

export function FormatDate(inputDate: any) {
	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	const dateParts = inputDate.split(' ')[0].split('-');
	const formattedDate = `${months[parseInt(dateParts[1], 10) - 1]}-${dateParts[2]}-${dateParts[0]
		} ${inputDate.split(' ')[1]}`;

	const inputDateTime = new Date(inputDate).getTime();
	const currentTime = new Date().getTime();
	const timeDifference = currentTime - inputDateTime;
	const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

	let distance = '';
	if (daysDifference === 0) {
		distance = 'today';
	} else if (daysDifference === 1) {
		distance = 'yesterday';
	} else if (daysDifference > 1 && daysDifference <= 30) {
		distance = `${daysDifference} days ago`;
	} else if (daysDifference > 30 && daysDifference <= 60) {
		distance = 'a month ago';
	} else if (daysDifference > 60 && daysDifference <= 365) {
		const monthsAgo = Math.floor(daysDifference / 30);
		distance = `${monthsAgo} months ago`;
	} else {
		const yearsAgo = Math.floor(daysDifference / 365);
		distance = `${yearsAgo} years ago`;
	}

	return { formattedDate, distance };
}

export const formatDate = (inputDate: any): string => {
	const date = new Date(inputDate);
	const formattedDate = date.toISOString().split('T')[0]; // Extract YYYY-MM-DD
	return formattedDate;
};

export function convertToMonthName(inputDate: any) {
	const date = new Date(inputDate);
	const options = { year: 'numeric', month: 'long', day: 'numeric' };
	//@ts-ignore
	return date.toLocaleString('en-US', options);
}

export function convertToAMPM(timeStr: string) {
	if (!timeStr) return '';

	const normalized = timeStr.length === 5
		? `${timeStr}:00`
		: timeStr;

	const timeObj = new Date(`2000-01-01T${normalized}`);

	if (isNaN(timeObj.getTime())) {
		console.warn('Invalid time:', timeStr);
		return timeStr;
	}

	return timeObj.toLocaleTimeString([], {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
	});
}

/**
 * Calculate working hours between checkIn and checkOut,
 * considering day boundary starts at 6 AM.
 * If checkout is after next day 6 AM, return pending (-1).
 *
 * @param checkIn string e.g. "12:23:07 PM"
 * @param checkOut string e.g. "07:15:00 AM" or null
 * @param date string e.g. "2025-07-11" (date for checkIn)
 */
export function calculateWorkingHoursCustomDay(
	checkIn: string,
	checkOut: string | null,
	date: string,
	dayStartHour = 6,
): { hours: number; minutes: number; pending: boolean } {
	if (!checkIn) return { hours: 0, minutes: 0, pending: false };

	// Parse check-in and checkout full datetime (date + time)
	const checkInDateTime = parseDateTime(date, checkIn);
	let checkOutDateTime = checkOut ? parseDateTime(date, checkOut) : new Date();

	// Adjust checkout if it's earlier than check-in (overnight)
	if (checkOutDateTime <= checkInDateTime) {
		checkOutDateTime.setDate(checkOutDateTime.getDate() + 1);
	}

	// Define day start boundary
	const dayStart = new Date(date);
	dayStart.setHours(dayStartHour, 0, 0, 0);

	// Define next day start boundary (6 AM next day)
	const nextDayStart = new Date(dayStart);
	nextDayStart.setDate(nextDayStart.getDate() + 1);

	// If checkout is after next day 6 AM, mark pending
	if (checkOutDateTime > nextDayStart) {
		return { hours: 0, minutes: 0, pending: true };
	}

	// Calculate difference in milliseconds within custom day boundary
	let diffMs = checkOutDateTime.getTime() - checkInDateTime.getTime();
	if (diffMs < 0) diffMs += 24 * 60 * 60 * 1000; // fallback if negative (overnight)

	const diffMinutes = Math.floor(diffMs / (1000 * 60));
	const hours = Math.floor(diffMinutes / 60);
	const minutes = diffMinutes % 60;

	return { hours, minutes, pending: false };
}

// Helper to parse date and time string to Date object
function parseDateTime(dateStr: string, timeStr: string): Date {
	// timeStr example: "12:23:07 PM"
	const [time, period] = timeStr.trim().split(' ');
	const [h, m, s] = time.split(':').map(Number);
	let hour = h;
	if (period === 'PM' && hour !== 12) hour += 12;
	if (period === 'AM' && hour === 12) hour = 0;

	const dt = new Date(dateStr);
	dt.setHours(hour, m, s || 0, 0);
	return dt;
}

export function convertToMinutes(time) {
	if (!time) {
		return 0; // Return 0 for no time input
	}

	const [hourMinute, period] = time.split(' ');
	const [hour, minute] = hourMinute.split(':').map(Number);
	let totalMinutes = hour * 60 + minute;

	if (period === 'PM' && hour !== 12) {
		totalMinutes += 12 * 60; // Convert PM times to 24-hour format
	} else if (period === 'AM' && hour === 12) {
		totalMinutes -= 12 * 60; // Convert 12 AM to 0 hours
	}

	return totalMinutes;
}

export function getCurrentTimeInMinutes() {
	const currentTime = new Date();
	const currentHour = currentTime.getHours();
	const currentMinute = currentTime.getMinutes();
	return currentHour * 60 + currentMinute;
}

//@ts-ignore
export function convertToISODate(inputObject) {
	if (!inputObject?.startDate || !inputObject?.endDate) {
		return null;
	}
	//@ts-ignore
	const convertDate = (dateString) => {
		const months = {
			Jan: '01',
			Feb: '02',
			Mar: '03',
			Apr: '04',
			May: '05',
			Jun: '06',
			Jul: '07',
			Aug: '08',
			Sep: '09',
			Oct: '10',
			Nov: '11',
			Dec: '12',
		};

		const [month, day, year] = dateString.split(' ');
		//@ts-ignore
		return `${year}-${months[month]}-${day.slice(0, -1).padStart(2, '0')}`;
	};

	return {
		start_date: convertDate(inputObject.startDate),
		end_date: convertDate(inputObject.endDate),
	};
}

export function convertTo24HourFormat(time: any) {
	// Split the time string into hours, minutes, and AM/PM
	const [timeStr, meridian] = time.split(' ');

	// Split the hours and minutes
	const [hoursStr, minutesStr] = timeStr.split(':');

	// Convert hours to integer
	let hours = parseInt(hoursStr, 10);

	// If it's PM and not already 12 PM, add 12 hours
	if (meridian === 'PM' && hours !== 12) {
		hours += 12;
	}

	// If it's AM and 12 AM, set hours to 0
	if (meridian === 'AM' && hours === 12) {
		hours = 0;
	}

	// Convert hours and minutes to 2-digit format
	const formattedHours = String(hours).padStart(2, '0');
	const formattedMinutes = String(minutesStr).padStart(2, '0');

	// Return the time in 24-hour format
	return `${formattedHours}:${formattedMinutes}`;
}

export const isPathInMenu = (path, menu) => {
	return Object.values(menu).some((submenu) => {
		return Object.values(submenu).some((item) => {
			//@ts-ignore
			return Object.values(item)?.some((subItem) => subItem?.path === path);
		});
	});
};

export function calculateOverallAverageWorkingHours(attendance) {
	let totalHours = 0;
	let totalLogs = 0;

	attendance.forEach((log) => {
		const checkIn = log?.check_in;
		const checkOut = log?.check_out;

		if (checkOut) {
			let checkInTime = new Date(`01/01/2000 ${checkIn}`);
			let checkOutTime = new Date(`01/01/2000 ${checkOut}`);

			if (checkOutTime.getTime() < checkInTime.getTime()) {
				checkOutTime.setDate(checkOutTime.getDate() + 1);
			}

			const workingHours =
				(checkOutTime.getTime() - checkInTime.getTime()) / (1000 * 60 * 60);

			if (!isNaN(workingHours)) {
				totalHours += workingHours;
				totalLogs++;
			}
		}
	});

	const overallAverage = totalLogs > 0 ? totalHours / totalLogs : 0;

	// Convert overall average hours to hours and minutes
	const overallAvgHours = Math.floor(overallAverage);
	const overallAvgMinutes = Math.round((overallAverage - overallAvgHours) * 60);

	return { hours: overallAvgHours, minutes: overallAvgMinutes };
}

export function updatedConvertToAMPM(timeStr: string): string {
	if (!timeStr) return '';

	// Ensure timeStr is in HH:mm:ss
	const [h = '00', m = '00', s = '00'] = timeStr.split(':');
	const date = new Date();
	date.setHours(+h, +m, +s);

	return date.toLocaleTimeString('en-US', {
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: true,
	});
}

/**
 * Format a date into: "Mon, July 21, 2025"
 *
 * @param date - Date string or null/undefined
 * @returns Formatted date string or "-"
 *
 * @example
 * updateFormattedDate("2025-07-21") // "Mon, July 21, 2025"
 */
export const updateFormattedDate = (date: string | undefined | null): string => {
	if (!date) return '-';
	return dayjs(date).format('ddd, MMM D, YYYY');
};

/**
 * Format a date into: "Jul 21, 2025"
 *
 * @param date - Date string or null/undefined
 * @returns Short formatted date or "-"
 *
 * @example
 * formatShortDate("2025-07-21") // "Jul 21, 2025"
 */
export const formatShortDate = (date: string | undefined | null): string => {
	if (!date) return '-';
	return dayjs(date).format('MMM D, YYYY');
};

/**
 * Attendance label based on date range.
 * - If both dates are today: "Today Attendance"
 * - If same day: "Attendance for July 21, 2025"
 * - If date range: "Attendance from July 21 2025 - July 23, 2025"
 *
 * @param startDate - Start date in ISO format (e.g. "2025-07-21")
 * @param endDate - End date in ISO format (e.g. "2025-07-23")
 * @returns A descriptive attendance label
 *
 * @example
 * getDateAttendanceLabel("2025-07-21", "2025-07-21") // "Attendance for July 21, 2025"
 */
export const getDateAttendanceLabel = (startDate: string, endDate: string): string => {
	const today = dayjs().format('YYYY-MM-DD');

	if (startDate === today && endDate === today) {
		return 'Today Attendance';
	} else if (startDate === endDate) {
		return `Attendance for ${dayjs(startDate).format('MMMM D, YYYY')}`;
	} else {
		return `Attendance from ${dayjs(startDate).format('MMMM D YYYY')} - ${dayjs(endDate).format(
			'MMMM D, YYYY',
		)}`;
	}
};

export const handleCtrlNavigation = (
	event: React.MouseEvent,
	navigate: (path: string, options?: any) => void,
	path: string,
	state?: any,
) => {
	if (event.ctrlKey || event.metaKey) {
		const url = new URL(window.location.origin);
		url.pathname = path;

		if (state && state.attendance_device_id) {
			url.searchParams.set('ud_id', state.attendance_device_id);
		}
		window.open(url.toString(), '_blank');
	} else {
		navigate(path, { state });
	}
};

export const NOTICE_PERIOD_MAPPING = {
	intern: 'INTERN_NOTICE_PERIOD',
	probation: 'PROBATION_NOTICE_PERIOD',
	permanent: 'PERMANENT_NOTICE_PERIOD',
};

export function formatConfigKey(key: string): string {
	if (!key) return "";

	// Trim spaces
	let formatted = key.trim();

	// Replace spaces or non-alphanumeric with underscores
	formatted = formatted.replace(/[^A-Za-z0-9]+/g, "_");

	// Remove leading/trailing underscores
	formatted = formatted.replace(/^_+|_+$/g, "");

	// Convert to uppercase
	formatted = formatted.toUpperCase();

	return formatted;
}

export const getVisibleConfigValue = (value: string) => {
	return /^\*+$/.test(value) ? "" : value;
};

function pluralize(value: number, unit: string): string {
	return `${value} ${unit}${value === 1 ? "" : "s"}`;
}

export function getEmployeeSince(
	joinDate: string | Date,
	isActive?: number,
	exitDate?: string | Date | null
): string {
	if (!joinDate) return "";

	const start = new Date(joinDate);

	// If employee is inactive and has an exit date → use exit date
	let end: Date;
	if (isActive === 0 && exitDate) {
		end = new Date(exitDate);
	} else {
		end = new Date(); // fallback → current date
	}

	// Future join date case
	if (start > end) {
		return "Not joined yet";
	}

	let years = end.getFullYear() - start.getFullYear();
	let months = end.getMonth() - start.getMonth();
	let days = end.getDate() - start.getDate();

	// Adjust days
	if (days < 0) {
		months--;
		const prevMonthDays = new Date(end.getFullYear(), end.getMonth(), 0).getDate();
		days += prevMonthDays;
	}

	// Adjust months
	if (months < 0) {
		years--;
		months += 12;
	}

	const parts = [
		years > 0 ? pluralize(years, "year") : null,
		months > 0 ? pluralize(months, "month") : null,
		days > 0 ? pluralize(days, "day") : null,
	].filter(Boolean) as string[];

	if (parts.length === 0) return "Today";

	return parts.join(", ");
}

export function textCleaner(reason?: string) {
	if (!reason) return "";
	return reason.replace(/^"|"$/g, '').replace(/\.$/, '');
}

export const formatValue = (val) => {
	if (val === null || val === '' || val === undefined) return '—';
	const str = String(val).trim();
	return str.startsWith('"') && str.endsWith('"') ? str.slice(1, -1) : str;
};


export const formatDateTime = (utcTimestamp: string) => {
	if (!utcTimestamp) return { date: '', time: '' };

	try {
		const date = new Date(utcTimestamp);

		// Get UTC hours and convert to Pakistan time (no timezone conversion needed)
		// UTC time is already the correct hour, just interpret it as Pakistan time
		const utcHours = date.getUTCHours();
		const utcMinutes = date.getUTCMinutes();
		const utcSeconds = date.getUTCSeconds();

		// Format date
		const options: Intl.DateTimeFormatOptions = {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		};
		const formattedDate = date.toLocaleDateString('en-US', options);

		// Convert 24-hour to 12-hour format
		let hours = utcHours;
		const ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12;
		hours = hours ? hours : 12; // 0 should be 12

		// Format time manually
		const formattedTime = `${hours.toString().padStart(2, '0')}:${utcMinutes
			.toString()
			.padStart(2, '0')}:${utcSeconds.toString().padStart(2, '0')} ${ampm}`;

		return {
			date: formattedDate,
			time: formattedTime,
		};
	} catch (error) {
		return { date: '', time: '' };
	}
};

export const getCurrentYearRange = () => {
	return {
		start_date: dayjs().startOf('year').format('YYYY-MM-DD'),
		end_date: dayjs().endOf('year').format('YYYY-MM-DD'),
	};
};

export const getTodayISO = (): string => {
	const d = new Date();
	const yyyy = d.getFullYear();
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const dd = String(d.getDate()).padStart(2, '0');
	return `${yyyy}-${mm}-${dd}`;
};